var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-container"},[(_vm.itemsInCart === 0)?_c('div',[_c('h4',[_vm._v("Nie masz nic w koszyku")])]):_vm._l((_vm.getCart),function(order){return _c('cart-order',{key:order.actionId,attrs:{"order":order}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }